import React from 'react'
import { useScrollReveal } from '../hooks/useScrollReveal'

interface DownloadSectionProps {
  getAppHref: string
  appStoreURL: string
  playStoreURL: string
  qrCodeSrc: string
}

const DownloadSection: React.FC<DownloadSectionProps> = ({ getAppHref, appStoreURL, playStoreURL, qrCodeSrc }) => {
  const { ref, visible } = useScrollReveal<HTMLElement>()

  return (
    <section id="download" ref={ref} className={`v2-download v2-reveal ${visible ? 'is-visible' : ''}`}>
      <h2 className="v2-download__title">
        See you in <em>real life</em>.
      </h2>
      <p className="v2-download__subtitle">Live in Chicago. Totally free.</p>

      <div className="v2-download__cta-row">
        <a href={getAppHref} className="v2-btn v2-btn--primary v2-btn--lg">
          Get the app
        </a>
        <div className="v2-download__qr">
          <a aria-label="Download Ivy" className="v2-qr-link" href={getAppHref}>
            <img alt="QR code to download Ivy" height={140} width={140} src={qrCodeSrc} />
          </a>
          <span>Scan to download</span>
        </div>
      </div>

      <div className="v2-download__stores">
        <a href={appStoreURL} target="_blank" rel="noopener noreferrer">
          App Store
        </a>
        <a href={playStoreURL} target="_blank" rel="noopener noreferrer">
          Google Play
        </a>
      </div>

      <p className="v2-download__disclaimer">18+ · Profiles stay hidden until you check in</p>
    </section>
  )
}

export default DownloadSection
